// extracted by mini-css-extract-plugin
module.exports = {"solarEnergy":"styles_solarEnergy__Opzra","bannerImage":"styles_bannerImage__6yAm0"};